import React from 'react';

const ImageDisplay = ({ imgURL }) => {
//   Assuming your image is named 'example.jpg' and is in the public folder
//   const imagePath = process.env.PUBLIC_URL + '/example.jpg';

  const imageStyle = {
    width: '128px',
    height: '128px',
    borderRadius: '10px',  // Adjust this value for more or less rounded edges
    objectFit: 'cover',
  };

  return (
    <div className="image-container">
      <img 
        src={imgURL} 
        style={imageStyle}
        alt="Example Image" 
        className="displayed-image"
      />
    </div>
  );
};

export default ImageDisplay;